import React from "react";
import { useRouter } from "next/navigation";
import { ActionCardItem, ClusterActionCards } from "@/components/PagePiller/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import Slider, { Slide } from "@/components/Slider";
import IconRight from "$/icons/icon-right.svg";
import IconLeft from "$/icons/icon-left.svg";
import routes from "@/helpers/router";
import BabyLookLike from "@/components/BabyLookLike";
import { RegisterRefType } from "@/components/PageHome/interfaces";
import { useAppSelector } from "@/redux/hooks";
import SegmentInfoSelector from "@/redux/slice/auth/selectors/userSegmentInfo";
import { assetClickedEvent } from "@/helpers/TSDEvents";
import { getPlainTexts } from "@/helpers";
import { NON_ONBOARDED_STATUS, ONBOARDING_STATUS } from "@/helpers/constants";
import styles from "./ClusterActionCards.module.scss";

interface ClusterActionCardsProps {
  data: ClusterActionCards;
  userAgent: DeviceInfo;
  registerRef?: RegisterRefType;
  assetPosition?: number;
}

const ClusterActionCardsComponent: React.FC<ClusterActionCardsProps> = ({
  data,
  userAgent,
  registerRef,
  assetPosition,
}) => {
  const { Title: title, ActionCards } = data;
  const { isMobile, isDesktop } = userAgent;

  const router = useRouter();
  const SegmentInfoObject = useAppSelector(SegmentInfoSelector);

  return (
    <section
      data-ref_id={data?.refId}
      ref={(el) => {
        if (data?.ShowHeadingInIndex && registerRef && data?.refId) registerRef(data?.refId, el);
      }}
      className={`scrollMargin spacingBetweenSections`}
    >
      {title && <div className={`container ${styles.title}`} dangerouslySetInnerHTML={{ __html: title }} />}
      <div className={`${styles.sliderWrapper} container ${isMobile ? styles.hidden : ""}`}>
        <Slider
          autoplay={false}
          slidesToShow={isMobile ? 1.5 : 2}
          columnGap={isMobile ? 16 : 20}
          showArrows={isDesktop}
          showDots={false}
          overflow={isMobile ? "visible" : "hidden"}
          nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
          prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
        >
          {ActionCards.map((card: ActionCardItem, index) => {
            const { Title, ClusterSlug, Image, CTAText, Description } = card;
            const redirectUrl = routes.cluster(ClusterSlug);

            return (
              <Slide index={index} key={ClusterSlug}>
                <BabyLookLike
                  iconUrl={Image?.data?.attributes?.url}
                  backgroundColour={index % 2 === 0 ? "#D7DFFF" : "#F15A24"}
                  title={Title}
                  description={Description}
                  ctaText={CTAText}
                  onClick={() => {
                    assetClickedEvent({
                      asset_name: getPlainTexts(title),
                      asset_display_text: getPlainTexts(Title),
                      asset_position: assetPosition,
                      asset_element_position: index + 1,
                      momverse_stage: SegmentInfoObject?.type
                        ? (ONBOARDING_STATUS[SegmentInfoObject?.type] ?? "")
                        : NON_ONBOARDED_STATUS,
                    });
                    router.push(redirectUrl);
                  }}
                  redirectUrl={redirectUrl}
                />
              </Slide>
            );
          })}
        </Slider>
      </div>
    </section>
  );
};

export default ClusterActionCardsComponent;
